import 'css/main'

import React from 'react'
import ReactDOM from 'react-dom'
import routes from 'configs/routes'
import { getUser } from 'utils/api'
import { Provider } from 'react-redux'
import { createAction } from 'redux-actions'
import configureStore from 'configs/configureStore'
import { Router, browserHistory } from 'react-router'
import { getItem, deleteItem } from 'utils/localStorage'

const store = configureStore()

const token = getItem('wideeyes-token')
if (token) {
  getUser(token)
    .then(res => {
      store.dispatch(createAction('GET_USER_COMPLETED')({...res, token}))
      main()
    })
    .catch(() => {
      deleteItem('wideeyes-token')
      main()
    })
} else {
  main()
}

function main () {
  ReactDOM.render((
    <Provider store={store}>
      <Router history={browserHistory} routes={routes} />
    </Provider>
  ), document.getElementById('root'))
}



// WEBPACK FOOTER //
// ./src/index.js